import React from 'react';
import history from 'dashboard/history';
import SashiDoLogo from 'components/SashiDoLogo/SashiDoLogo.react';
import styles from 'components/Sidebar/Sidebar.scss';
import Icon from 'components/Icon/Icon.react';

import Tooltip from 'rc-tooltip';

const SidebarHeader = ({}) => (
  <div className={styles.header}>
    <SashiDoLogo link tooltip />
    <p>Powered by CloudStrap</p>
    <Tooltip placement="right" overlay="Based on Parse Open Source. 100% improved by SashiDo for best experience." overlayClassName={styles.rcTooltipLogoVersion} arrowContent={<div className="rc-tooltip-arrow-inner" />}>
      <span className={styles.dashBoardVersion}>v2.0.0+</span>
    </Tooltip>

    <Tooltip placement="right" overlay="Give 30 days, Get $15 + 50k requests!" arrowContent={<div className="rc-tooltip-arrow-inner" />}>
      <span className={styles.referral} onClick={() => { history.push('/referrals'); }}>
        <span>Get $15</span>
        <Icon width={22} height={22} name="icon-coins" />
      </span>
    </Tooltip>

    {
      // <Tooltip placement="right" overlay={'Get Your X-Mas Gift!'} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
      //   <span className={styles.referral} onClick={() => { history.push(`/backups`) }}>
      //     <span><strong>X-Mas</strong></span>
      //     <Icon width={30} height={30} name='icon-gift' />
      //   </span>
      // </Tooltip>
    }
  </div>
);

export default SidebarHeader;
